import { render, staticRenderFns } from "./BarcodeOrderDeliverySignatures.vue?vue&type=template&id=71c381d7&scoped=true"
import script from "./BarcodeOrderDeliverySignatures.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderDeliverySignatures.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeOrderDeliverySignatures.vue?vue&type=style&index=0&id=71c381d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c381d7",
  null
  
)

export default component.exports